import { useEffect, useRef, useState } from 'react';
import { useForm } from '@/form/useForm.ts';
import { ConfigSlideId } from '@/eventConfig/types.ts';
import { andBoolArray } from '@/form/utils.tsx';
import { FormDataType } from '@/form/FormProvider.tsx';

export const useSummaryFormField = ({ slideIds }: { slideIds: ConfigSlideId[] }) => {
  const { onChange, getFormData, validateSlide } = useForm();

  const formSnapshot = useRef<FormDataType>(getFormData());
  const [editMode, setEditMode] = useState<boolean>(false);

  useEffect(() => {
    resetFormData();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  const slideValids = slideIds.map((slideId) => {
    return validateSlide(slideId);
  });
  const isValid = andBoolArray(slideValids);
  const onStartEdit = () => {
    formSnapshot.current = getFormData();
    setEditMode(true);
  };

  const onCancelEdit = () => {
    resetFormData();
    setEditMode(false);
  };

  const resetFormData = () => {
    // Call onChange on all the values that were temporarily saved on "edit start"
    Object.keys(formSnapshot.current).map((fieldName: string) => {
      onChange(fieldName, formSnapshot.current[fieldName]);
    });
  };

  const onSave = () => {
    setEditMode(false);
  };

  return {
    onStartEdit,
    onCancelEdit,
    onSave,
    editMode,
    isValid,
  };
};
